import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const UpdateProfile = Loadable(lazy(() => import('views/update-profile')));
const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const SamplePageRole = Loadable(lazy(() => import('views/sample-page-role')));
const SampleAdminPage = Loadable(lazy(() => import('views/sample-admin-page')));
const SampleAddCustomerPage = Loadable(lazy(() => import('views/sample-add-customer-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-typography',
          element: <UtilsTypography />
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-color',
          element: <UtilsColor />
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-shadow',
          element: <UtilsShadow />
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'tabler-icons',
          element: <UtilsTablerIcons />
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'material-icons',
          element: <UtilsMaterialIcons />
        }
      ]
    },
    {
      path: 'update-profile',
      element: <UpdateProfile />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'sample-admin-page',
      element: <SampleAdminPage />
    },
    {
      path: 'sample-page-role',
      element: <SamplePageRole />
    },
    {
      path: 'sample-add-customer-page',
      element: <SampleAddCustomerPage />
    },
    
  ]
};

export default MainRoutes;
